<!----------------------------   Program description   ----------------------------
- Vue Name ID   : refndReqstPopup
- Vue Name  : 환불신청 팝업
- Author      :
- Create Date : 2021.05.26
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div class="layer-content"
       v-if="showAt">
    <div class="balance-sort-wrap">
      <div class="balance-sort-con box-type04 mgr5">
        <div class="__in">
          <div class="entry-cho"><span class="label-txt">{{ fcltNm }}</span></div>
          <table class="tb-row">
            <colgroup>
              <col style="width:20%;">
              <col style="width:80%;">
            </colgroup>
            <tbody>
            <tr>
              <th style="text-align: left;">
                <span>청구항목</span>
              </th>
              <td>{{param.goodsNm}}</td>
            </tr>
            <tr>
              <th style="text-align: left;">
                <span>결제방법</span>
              </th>
              <td>{{goodsOrderSetleInfo.setleMthNm}}</td>
            </tr>
            <tr>
              <th style="text-align: left;">
                <span>금액</span>
              </th>
              <td>
                {{ $onbiLib.addComma(goodsOrderSetleInfo.setleAmount) }} 원
              </td>
            </tr>
            <tr>
              <th style="text-align: left;"
                  rowspan="2">
                <span>환급계좌</span>
              </th>
              <td>
                <select style="width: 30%;"
                        v-model="refndReqstInfo.bankCode" >
                  <option v-for="(info,index) in bankList"
                          :key="'bankList' + index"
                          :value="info.cd">
                    {{info.cdNm}}
                  </option>
                </select>
                <input type="text" class="txt mgl10"
                       style="width:67% !important;"
                       @keydown="$onbiLib.onlyNumberKeydown()"
                       @keyup="$onbiLib.onlyNumberKeyup()"
                       maxlength="20"
                       ref="acnutno"
                       v-model="refndReqstInfo.acnutno"/>
              </td>
            </tr>
            <tr>
              <td style="font-size: 13px;">※ 카드 결제는 취소 가능 기간이 지난 경우 환급계좌로 환불됩니다.</td>
            </tr>
            <tr>
              <th style="text-align: left;">
                <span>예금주명</span>
              </th>
              <td>
                <input type="text" class="txt"
                       style="width:100%; !important;"
                       maxlength="15"
                       ref="dpstr"
                       v-model="refndReqstInfo.dpstr"/>
              </td>
            </tr>
            <tr>
              <th style="text-align: left;">
                <span>사유</span>
              </th>
              <td>
                  <textarea cols="30"
                            rows="4"
                            id="cn"
                            ref="refndMemo"
                            style="width:100%;resize: none;"
                            maxlength="600"
                            placeholder="사유를 입력해주세요."
                            v-model="refndReqstInfo.refndMemo">
                  </textarea>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="btn-wrap t-line center" style="border-top:0;">
      <button class="big _bt-white"
              @click="closePopup()">
        <span>취소</span>
      </button>
      <button class="big _bt-navy"
              @click="saveRefndReqst()">
        <span>환불신청</span>
      </button>
    </div>
  </div>
</template>

<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
 * 2.1. Import
 *======================================================================================*/
export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  nm: 'refndReqstPopup',
  props: ['param', 'index'],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data: function () {
    return {
      showAt: false,
      fcltcd: '',
      fcltNm: '',
      bankList: new Array(),
      refndReqstInfo: new Map(),
      goodsOrderSetleInfo: new Map(),
      def: {
        refndReqstInfo: {
          setleNo: '',
          orderNo: '',
          refndSttusCode: '001',
          bankCode: '',
          acnutno: '',
          dpstr: '',
          refndMemo: '',
        },
      },
    }
  },
  computed : {
    mberInfo : function(){
      return this.$store.getters.getMberInfo;
    },
    validInfo: function(){
      let validInfo = {
        at: false,
        trgetNm: '',
        msg: ''
      }

      if(this.refndReqstInfo.bankCode == '' && !validInfo.at){
        validInfo.at = true;
        validInfo.msg = '은행을 선택해주세요.';

      }

      if(this.refndReqstInfo.acnutno == '' && !validInfo.at){
        validInfo.at = true;
        validInfo.trgetNm = 'acnutno';
        validInfo.msg = '계좌를 입력해주세요.';

      }

      if(this.refndReqstInfo.dpstr == '' && !validInfo.at){
        validInfo.at = true;
        validInfo.trgetNm = 'dpstr';
        validInfo.msg = '예금주명을 입력해주세요.';

      }

      if(this.refndReqstInfo.refndMemo == '' && !validInfo.at){
        validInfo.at = true;
        validInfo.trgetNm = 'refndMemo';
        validInfo.msg = '사유를 입력해주세요.';
      }

      return validInfo;
    }
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  methods: {
    init: function () {
      const searchInfo = {cdGrp : 'BNK'};

      this.$onbiLib.searchCmmnCodeList(searchInfo).then(function(codeList){
        this.bankList = codeList;
        this.bankList.splice(0, 0, {cd: "", cdNm: "선택"});

        this.fcltcd = this.param.fcltcd;
        this.fcltNm = this.param.fcltNm;
        this.goodsOrderSetleInfo = this.param.goodsOrderSetleInfo;
        this.def.refndReqstInfo.orderNo = this.param.goodsOrderSetleInfo.orderNo;
        this.def.refndReqstInfo.setleNo = this.param.goodsOrderSetleInfo.setleNo;

        this.refndReqstInfo = JSON.parse(JSON.stringify(this.def.refndReqstInfo));

        this.showAt = true;
      }.bind(this));
    },
    saveRefndReqst: function(){
      if(this.validInfo.at){
        this.$toasted.show(this.validInfo.msg);
        this.$refs[this.validInfo.trgetNm].focus();
        return false;
      }

      this.axios.post('/i5gam/goods/saveRefndReqst.act',{
        refndReqstInfo: this.refndReqstInfo,
        mberNo: this.mberInfo.mberNo,
      }).then(function(response) {
        const code = response.data.procInfo.code;
        if(code == '000'){
          this.$toasted.show(this.$onbiLib.msg.suc.reg, {duration:1000, type:'success'});
          this.param.callbackFunc();
          this.closePopup();
        }
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    closePopup: function(){
      this.$store.commit('closePopup', this.index);
    }
  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted: function () {
    this.init();
  }
}
</script>
<!-------------------------------------------------------------------------------------
- 3. 뷰 스타일 block
--------------------------------------------------------------------------------------->
<style scoped>
</style>